var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('h4',[_vm._v("\n    Menu\n    "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{ name: 'menus.create' }}},[_vm._v("Create")])],1),_c('pages-base-table',{attrs:{"resource":_vm.resource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }